import React, { forwardRef } from "react";
import "./tablelayoutItem.css";
import { currencyFormate, parseNumeric } from "../Date_Formate_Utilitiy/Index";

const TableLayoutItem = forwardRef(
  (
    {
      children,
      total_inwards_quantity,
      total_outwards_quantity,
      total_closing_quantity,
      total_inwards_value,
      total_outwards_value,
      total_closing_value,
      unit_name = "",
      data,
    },
    ref,
  ) => {
    const openingQty = parseNumeric(data?.opening_data?.quantity);
    const openingVal = parseNumeric(data?.opening_data?.value);
    const inwardQty = parseNumeric(total_inwards_quantity);
    const inwardVal = parseNumeric(total_inwards_value);

    const updated_inward_total =
      inwardQty + openingQty === 0
        ? ""
        : currencyFormate(inwardQty + openingQty);
    const updated_inward_value =
      inwardVal + openingVal === 0
        ? ""
        : currencyFormate(inwardVal + openingVal);
    const normalizedUnitName = String(unit_name || "")
      .replace(/\s+/g, " ")
      .trim();
    return (
      <div className="custom_container">
        <div className="custom_row border_2_1px_bottom">
          <div
            style={{ width: "7%" }}
            className="col-2 m-0 p-0 pe-1 text-end table_header_font"
          >
            Date
          </div>
          <div
            style={{ width: "24%" }}
            className="col-6 m-0 p-0 ps-1 text-start table_header_font"
          >
            Particular
          </div>
          <div
            style={{ width: "10%" }}
            className="col-2 m-0 p-0 text-start table_header_font"
          >
            Vch Type
          </div>
          <div
            style={{ width: "8%" }}
            className="col-2 m-0 p-0 pe-1 text-end table_header_font"
          >
            Vch No
          </div>

          <div
            style={{ width: "17%" }}
            className="col-4  border_2_1px_right border_2_1px_left m-0 p-0 table_header_font"
          >
            <b>Inwards</b>
            <div className="row m-0 p-0" style={{ width: "100%" }}>
              <div className="col-4 text-end p-0 m-0 table_header_font">
                Qty
              </div>
              <div className="col-3 table_header_font text-end p-0 m-0">
                Rate
              </div>
              <div className="col-5 text-end p-0 pe-1 m-0 table_header_font">
                Value
              </div>
            </div>
          </div>
          <div
            style={{ width: "17%" }}
            className="col-4 border_2_1px_right m-0 p-0 table_header_font"
          >
            <b>Outwards</b>
            <div className="row m-0 p-0" style={{ width: "100%" }}>
              <div className="col-4 text-end p-0 m-0 table_header_font">
                Qty
              </div>
              <div className="col-3 m-0 p-0 text-end table_header_font">
                Rate
              </div>
              <div className="col-5 text-end p-0 pe-1 m-0 table_header_font">
                Value
              </div>
            </div>
          </div>
          <div
            style={{ width: "17%" }}
            className="col-4 border_2_1px_right m-0 p-0 table_header_font"
          >
            <b>Closing Balance</b>
            <div className="row m-0 p-0" style={{ width: "100%" }}>
              <div className="col-4 text-end p-0 m-0 table_header_font">
                Qty
              </div>
              <div className="col-3 p-0 m-0 text-end table_header_font">
                Rate
              </div>
              <div className="col-5 text-end p-0 pe-1 m-0 table_header_font">
                Value
              </div>
            </div>
          </div>
        </div>

        <div
          className={`border_2_1px_bottom postion-relative`}
          style={{ height: "76.5vh", width: "100%" }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "76.5vh",
              overflowY: "scroll",
            }}
            ref={ref}
          >
            {children}
          </div>

          <div
            style={{ width: "100%", height: "100%" }}
            className={`custom_row_item`}
          >
            <div
              style={{ width: "7%" }}
              className="col-2 m-0 p-0 pe-1 text-end table_body_font"
            ></div>
            <div
              style={{ width: "24%" }}
              className="col-6 m-0 p-0 ps-1 table_body_font text-start"
            >
              {" "}
            </div>
            <div
              style={{ width: "10%" }}
              className="col-2 m-0 p-0 text-start table_body_font"
            ></div>
            <div
              style={{ width: "8%" }}
              className="col-2 m-0 p-0 text-end table_body_font"
            ></div>

            <div
              style={{ width: "17%", height: "100%" }}
              className="col-4  m-0 p-0 border_2_1px_right border_2_1px_left"
            >
              <div className="row m-0 p-0" style={{ width: "100%" }}>
                <div
                  className="col-4 text-end p-0 m-0 table_body_font"
                  style={{ overflow: "hidden", whiteSpace: "nowrap" }}
                ></div>
                <div
                  className="col-3 m-0 p-0 text-end table_body_font"
                  style={{ overflow: "hidden" }}
                >
                  {/* {currencyFormate(data?.opening_data?.rate)} */}
                </div>
                <div
                  className="col-5 text-end p-0 m-0 pe-1 table_body_font"
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    wordSpacing: -7,
                  }}
                >
                  {/* {currencyFormate(data?.opening_data?.value)} */}
                </div>
              </div>
            </div>
            <div
              style={{ width: "17%", height: "100%" }}
              className="col-4  m-0 p-0 border_2_1px_right"
            >
              <div className="row m-0 p-0" style={{ width: "100%" }}>
                <div className="col-4 text-end p-0 m-0 table_body_font">
                  {/* {data?.opening_data?.quantity} */}
                </div>
                <div className="col-3 m-0 p-0 text-end table_body_font">
                  {/* {currencyFormate(data?.opening_data?.rate)} */}
                </div>
                <div className="col-5 text-end p-0 pe-1 m-0 table_body_font">
                  {/* {currencyFormate(data?.opening_data?.value)} */}
                </div>
              </div>
            </div>

            <div style={{ width: "17%" }} className="col-4  m-0 p-0">
              <div className="row m-0 p-0" style={{ width: "100%" }}>
                <div className="col-4 text-end p-0 m-0 table_body_font">
                  {/* {data?.opening_data?.quantity} */}
                </div>
                <div className="col-3 text-end m-0 p-0 table_body_font">
                  {/* {currencyFormate(data?.opening_data?.rate)} */}
                </div>
                <div className="col-5 text-end p-0 pe-1 m-0 table_body_font">
                  {/* {currencyFormate(data?.opening_data?.value)} */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{ width: "100%" }}
          className={`custom_row_item border_2_1px_bottom`}
        >
          <div
            style={{ width: "31%", whiteSpace: "nowrap" }}
            className="col-8 m-0 p-0 ps-1 table_body_font text-start"
          >
            <b>Grand Total</b>
          </div>
          <div
            style={{ width: "10%" }}
            className="col-2 m-0 p-0 text-start table_body_font"
          ></div>
          <div
            style={{ width: "8%" }}
            className="col-2 m-0 p-0 text-end table_body_font"
          ></div>

          <div
            style={{ width: "17%", height: "100%" }}
            className="col-4  m-0 p-0 border_2_1px_right border_2_1px_left"
          >
            <div className="row m-0 p-0" style={{ width: "100%" }}>
              <div
                className="col-4 text-end p-0 m-0 table_body_font"
                style={{
                  width: "45%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <b>{`${updated_inward_total} ${normalizedUnitName}`.trim()}</b>
              </div>
              <div
                className="col-3 m-0 p-0 text-end table_body_font"
                style={{ width: "15%", overflow: "hidden" }}
              ></div>
              <div
                className="col-5 text-end p-0 m-0 pe-1 table_body_font"
                style={{
                  width: "40%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  wordSpacing: -7,
                }}
              >
                <b>{updated_inward_value}</b>
              </div>
            </div>
          </div>
          <div
            style={{ width: "17%", height: "100%" }}
            className="col-4  m-0 p-0 border_2_1px_right"
          >
            <div className="row m-0 p-0" style={{ width: "100%" }}>
              <div
                className="col-4 text-end p-0 m-0 table_body_font"
                style={{
                  width: "45%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <b>
                  {total_outwards_quantity === 0
                    ? ""
                    : `${currencyFormate(total_outwards_quantity)} ${normalizedUnitName}`.trim()}
                </b>
              </div>
              <div
                className="col-3 m-0 p-0 text-end table_body_font"
                style={{ width: "15%" }}
              ></div>
              <div
                className="col-5 text-end p-0 pe-1 m-0 table_body_font"
                style={{
                  width: "40%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                <b>
                  {total_outwards_value === 0
                    ? ""
                    : currencyFormate(total_outwards_value)}
                </b>
              </div>
            </div>
          </div>

          <div style={{ width: "17%" }} className="col-4  m-0 p-0">
            <div className="row m-0 p-0" style={{ width: "100%" }}>
              <div
                className="col-4 text-end p-0 m-0 table_body_font"
                style={{
                  width: "45%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <b>
                  {total_closing_quantity === 0
                    ? ""
                    : `${currencyFormate(total_closing_quantity)} ${normalizedUnitName}`.trim()}
                </b>
              </div>
              <div
                className="col-3 text-end m-0 p-0 table_body_font"
                style={{ width: "15%" }}
              ></div>
              <div
                className="col-5 text-end p-0 pe-1 m-0 table_body_font"
                style={{
                  width: "40%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                <b>
                  {total_closing_value === 0
                    ? ""
                    : currencyFormate(total_closing_value)}
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default TableLayoutItem;
